export enum HttpVerb {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export interface LookupData {
  id: number
  name: string
  extendedAttributes1: string
}
